import SessionDB from './sessionStorage';

const ACTIVE_SHOP_KEY = 'sajilo_active_shop';
const SHOPS_KEY = 'sajilo_shops';
const AUTH_USER_KEY = 'sajilo_auth_user';

export interface ShopSummary {
    id: number;
    name: string;
    /** Caller's membership role in this shop (owner, frontdesk, studio, printing). */
    role?: string;
    [key: string]: any;
}

export interface AuthUser {
    username: string;
    name?: string | null;
    email: string | null;
    role: string;
}

export function getActiveShopId(): number | null {
    try {
        const v = localStorage.getItem(ACTIVE_SHOP_KEY);
        return v ? Number(v) : null;
    } catch {
        return null;
    }
}

export function setActiveShopId(id: number | null): void {
    try {
        if (id === null) localStorage.removeItem(ACTIVE_SHOP_KEY);
        else localStorage.setItem(ACTIVE_SHOP_KEY, String(id));
    } catch {
        /* ignore */
    }
}

export function getShops(): ShopSummary[] {
    try {
        const v = localStorage.getItem(SHOPS_KEY);
        return v ? (JSON.parse(v) as ShopSummary[]) : [];
    } catch {
        return [];
    }
}

export function setShops(shops: ShopSummary[]): void {
    try {
        localStorage.setItem(SHOPS_KEY, JSON.stringify(shops));
    } catch {
        /* ignore */
    }
}

export function getAuthUser(): AuthUser | null {
    try {
        const v = localStorage.getItem(AUTH_USER_KEY);
        return v ? (JSON.parse(v) as AuthUser) : null;
    } catch {
        return null;
    }
}

export function setAuthUser(user: AuthUser | null): void {
    try {
        if (user === null) localStorage.removeItem(AUTH_USER_KEY);
        else localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
    } catch {
        /* ignore */
    }
}

export function clearAuth(): void {
    try {
        localStorage.removeItem(ACTIVE_SHOP_KEY);
        localStorage.removeItem(SHOPS_KEY);
        localStorage.removeItem(AUTH_USER_KEY);
    } catch {
        /* ignore */
    }
    SessionDB.setAccessToken(null);
    SessionDB.setRefreshToken(null);
}
